module.exports = __webpack_public_path__ + "img/logo.174efc80.png";